<template>
  <section class="privateWallet">
    <div class="privateWallet-con">
      <div class="text"><title-desc-tutorial :title="$t('overview.privateWallet.title')" :descList="descList" :videoList="videoList"></title-desc-tutorial></div>
      <div class="privateWallet-img">
        <div class="imgbox">
          <img class="img1" src="../../assets/img/Mockup5@2x.png" />
        </div>
        <div class="imgbox wlaletImg" :class="{ move:anime }">
          <img class="img2" src="../../assets/img/Mockup4@2x.png" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import TitleDescTutorial from '../../components/common/title-desc-tutorial'

export default {
  components: {
    TitleDescTutorial
  },
  data() {
    return {
      descList: [
        this.$t('overview.privateWallet.list1'),
        this.$t('overview.privateWallet.list2'),
        this.$t('overview.privateWallet.list3')
      ],
      videoList: [
        {
          title: this.$t('overview.privateWallet.tutorial1'),
          url: 'https://youtu.be/h3MuPlKoJxk'
        },
        {
          title: this.$t('overview.privateWallet.tutorial2'),
          url: 'https://youtu.be/B4xsBLkrqb8'
        },
        {
          title: this.$t('overview.privateWallet.tutorial3'),
          url: 'https://youtu.be/9bZFA3Gz9cU'
        }
      ],
      imgNum: 0,
      imgElNum: 0,
      anime: false
    }
  },
  methods: {
    computImg () {
      this.imgNum += 1
      if (this.imgElNum === 0) {
        return false
      }
      if (this.imgNum === this.imgElNum) {
        this.mountAnime()
      }
    },
    mountAnime () {
      window.sr.reveal('.wlaletImg', {
        viewFactor: .3,
        scale: 1,
        duration: 0,
        origin: 'left',
        distance: '0',
        easing: 'ease-in',
        opacity: 1,
        delay: 0,
        afterReveal: () => {
          this.anime = true
        },
      })
    }
  },
  mounted () {
    let imgs = this.$el.getElementsByTagName('img')
    this.imgElNum = imgs.length
    for (let i = 0; i < imgs.length; i++) {
      let src = imgs[i].src
      imgs[i].src = ''
      imgs[i].addEventListener('load', () => {
        this.computImg()
      })
      imgs[i].src = src
    }
  }
}
</script>

<style lang="css" scoped>
.privateWallet {
  background-color: #F7CC09;
}
.privateWallet-con {
  max-width: 1200px;
  margin: auto;
  padding: 56px 20px 0;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.privateWallet-img {
  width: auto;
  max-width: 474px;
  display: flex;
  justify-content: flex-end;
  align-self: flex-end;
  align-items: flex-end;
  flex: 1;
  margin-left: 72px;
}
.text {
  max-width: 456px;
  width: auto;
}

.privateWallet-img .imgbox:nth-child(2) {
  margin-left: -206px;
}
.privateWallet-img .imgbox {
  width: auto;
  font-size: 0;
  transition: all .3s linear;
}

.privateWallet-img .imgbox:nth-child(1) {
  max-width: 310px;
}

.privateWallet-img .imgbox:nth-child(2) {
  max-width: 369px;
  transform: translateX(-79px);
  transition-delay: .1s;
}

.privateWallet-img img {
  width: 100%;
}

.move {
  transform: translateX(0) !important;
}

@media screen and (max-width: 768px) {
  .privateWallet-con {
    flex-direction: column;
    margin-top: -60px;
  }
  .text {
    width: 100%;
    max-width: 100%;
    padding-bottom: 24px;
  }
  .privateWallet-img {
    margin: 0 20px;
  }
  .privateWallet-img .imgbox:nth-child(2) {
    transform: translateX(-46px);
  }
}
</style>